import { useTheme } from '@mui/material';

export const AskInformMark = () => {
    const theme = useTheme();

    return (
        <svg
            width={26}
            height={26}
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.478 14.444a7.5 7.5 0 1 1 12.704-1.019l.575 2.833a.834.834 0 0 1-.983.984l-2.825-.584a7.498 7.498 0 0 1-9.471-2.214Zm.77-.699a6.309 6.309 0 0 1-1.18-2.735 6.254 6.254 0 0 1 .217-2.978A6.352 6.352 0 0 1 5.86 5.478a6.524 6.524 0 0 1 2.59-1.57 6.626 6.626 0 0 1 3.035-.243 6.573 6.573 0 0 1 2.814 1.14 6.41 6.41 0 0 1 1.977 2.27 6.272 6.272 0 0 1-.015 5.804l.499 2.408a.695.695 0 0 1-.197.643.726.726 0 0 1-.656.193l-2.449-.496a6.608 6.608 0 0 1-5.893.032 6.472 6.472 0 0 1-2.317-1.914Z"
                fill={theme.palette.text.primary}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.877 6.667a.6.6 0 0 1 .6-.6h.083a.6.6 0 1 1 0 1.2h-.084a.6.6 0 0 1-.6-.6Zm.639 3.566a.6.6 0 0 1 .6.6v2.5a.6.6 0 0 1-1.2 0v-2.5a.6.6 0 0 1 .6-.6Z"
                fill={theme.palette.text.primary}
            />
        </svg>
    );
};
